const keys = {
  hashKey: '53fd3f823c158f13437951b6835675cc35a4c42c4d473dbb2f378d1d86f885ba',
};

export default keys;
